module.exports = __webpack_public_path__ + "static/media/Paar-4-long.dc480818.jpg";